import { AdvertiserReportFilterInterface } from '../../../model/types/AdvertiserReportFilter.interface'
import { IAdOverviewFilter } from '../../../../ad-overview/model/types/AdOverviewFilter.interface'
import { IPpcComplianceFilter } from '../../../../ppc-compliance/model/types/PpcComplianceFilter.interface'
import { AppDispatch } from '../../../../../app/store/Store'
import {
  initialAdOverviewFilters,
  setAdOverviewFilter,
} from '../../../../ad-overview/model/adOverviewSlice'
import {
  initialPpcComplianceFilters,
  setPpcComplianceFilter,
} from '../../../../ppc-compliance/model/ppcComplianceSlice'

const withoutEmpty = <T extends object>(params: T) =>
  Object.fromEntries(Object.entries(params).filter(([, value]) => value)) as Partial<T>

const toQuery = (params: object) =>
  new URLSearchParams(Object.entries(params).map(([key, value]) => [key, `${value}`])).toString()

const pickReversed = (reversedFilters: string | undefined, keys: string[]) =>
  (reversedFilters ? reversedFilters.split(',') : []).filter((key) => keys.includes(key)).join(',')

const isReversed = (reversedFilters: string | undefined, key: string) =>
  !!reversedFilters?.split(',').includes(key)

const toAdOverviewFilters = (
  filters: AdvertiserReportFilterInterface,
  row: Pick<IAdOverviewFilter, 'adDomain' | 'affiliate' | 'advertiserName'>,
) => {
  const reversedKeys = ['engine_id', 'browser_id']

  if (row.affiliate === undefined) reversedKeys.push('affiliate_id')
  if (row.advertiserName === undefined) reversedKeys.push('advertiser_id')

  return withoutEmpty<Partial<IAdOverviewFilter>>({
    project: filters.project,
    dateRange: filters.dateRange,
    country: filters.country,
    engine: filters.engine,
    browser: filters.browser,
    policy: filters.policy,
    affiliate: filters.affiliate,
    advertiserName: filters.advertiserName,
    show_hidden: filters.show_hidden,
    is_decloak: filters.is_decloak,
    ...row,
    reversed_filters: pickReversed(filters.reversed_filters, reversedKeys),
  })
}

const toPpcComplianceFilters = (
  filters: AdvertiserReportFilterInterface,
  row: Pick<IPpcComplianceFilter, 'site'>,
) =>
  withoutEmpty<Partial<IPpcComplianceFilter>>({
    project: filters.project,
    dateRange: filters.dateRange,
    country: filters.country,
    engine: filters.engine,
    browser: filters.browser,
    affiliate: isReversed(filters.reversed_filters, 'affiliate_id') ? '' : filters.affiliate,
    advertiserName: filters.advertiserName,
    hidden: filters.show_hidden,
    adHijackers: filters.policy === 'ad_hijacking',
    ...row,
    reversed_filters: pickReversed(filters.reversed_filters, [
      'engine_id',
      'browser_id',
      'advertiser_id',
    ]),
  })

export const adOverviewLink = (
  filters: AdvertiserReportFilterInterface,
  row: Pick<IAdOverviewFilter, 'adDomain' | 'affiliate' | 'advertiserName'>,
  dispatch: AppDispatch,
) => {
  const target = toAdOverviewFilters(filters, row)

  return {
    to: `/adv-overview?${toQuery(target)}`,
    onClick: () => dispatch(setAdOverviewFilter({ ...initialAdOverviewFilters, ...target })),
  }
}

export const ppcComplianceLink = (
  filters: AdvertiserReportFilterInterface,
  row: Pick<IPpcComplianceFilter, 'site'>,
  dispatch: AppDispatch,
) => {
  const target = toPpcComplianceFilters(filters, row)

  return {
    to: `/ppc-compliance?${toQuery(target)}`,
    onClick: () =>
      dispatch(
        setPpcComplianceFilter({
          ...initialPpcComplianceFilters,
          ...target,
          shoppingAds: !!filters.show_shopping_ads,
        }),
      ),
  }
}
